import { withTheme } from 'theme';
import material3 from 'theme/material3';

const container = withTheme((theme) => ({
  width: '100%',
  paddingY: theme.spacing(3)
}));

const mainImgWrapper = withTheme((theme) => ({
  width: '100%',
  background: '#EAF2FA',
}));

const leftSubContainer = withTheme((theme) => ({
  width: '100%',
  [theme.breakpoints.up('md')]: {
    maxWidth: '50%'
  }
}));

const downloadButton = withTheme(() => ({
  height: '37.5px',
  overflow: 'hidden',
  minWidth: '144px',
  borderRadius: material3.shape.medium,
  lineHeight: '1.5',
  fontWeight: material3.typography.labelWeight,
  '&:hover': {
    background: material3.color.primaryLight,
  },
}));

const styles = {
  container,
  mainImgWrapper,
  leftSubContainer,
  downloadButton
};

export default styles;
